import {ThresholdData} from '../timeline/contract';

export enum ScanType {
    VISUAL_SCAN = 'VISUAL SCAN',
    WIFI_SCAN = 'WIFI SCAN'
}

export type CompareOption = {
    label: string;
    value: string;
    sessionTypeLabel?: string;
};

export type CompareScanData = {
    sessionId: string;
    type: ScanType;
    scanTypeLabel: string;
    date: string;
    floor?: string;
    room?: string;
    imageUrl?: string;
    insights?: string;
    rssi?: number;
    signalStrengthPercentage?: ThresholdData;
    info?: {
        downloadSpeed: string;
        signalStrength: string;
        uploadSpeed: string;
        connectedDevices: string;
        channelNumber: string;
    };
};
